// extracted by mini-css-extract-plugin
module.exports = {"Container":"ErrorMessage_Container__2QGpG","Button":"ErrorMessage_Button__3VFyJ","ErrorText":"ErrorMessage_ErrorText__nfMua","Icon":"ErrorMessage_Icon__qF721"};